import React from 'react'
import { shopService } from '@cabukaka/services';
import { Shop } from '@cabukaka/types';
import useDataById from '../core/useDataById';

export  function useShop({ id }: { id: string }) {
    const {
        data: shop,
        loading,
        error,
        deleteItem,
        updateItem
    } = useDataById<Shop>({ service: {
        ...shopService,
        ...shopService.baseService
    }, id });

    return {
     shop,
     error,
     loading,
     deleteShop: deleteItem,
     updateShop: updateItem,
    }

}
